
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class OthersDialog extends _Ext.DialogBase<OthersRow, any> {
        protected getFormKey() { return OthersForm.formKey; }
        protected getIdProperty() { return OthersRow.idProperty; }
        protected getLocalTextPrefix() { return OthersRow.localTextPrefix; }
        protected getNameProperty() { return OthersRow.nameProperty; }
        protected getService() { return OthersService.baseUrl; }
        protected getDeletePermission() { return OthersRow.deletePermission; }
        protected getInsertPermission() { return OthersRow.insertPermission; }
        protected getUpdatePermission() { return OthersRow.updatePermission; }
        protected useViewMode() { return true; }

        protected get_ExtDialogOptions() {
            let options = super.get_ExtDialogOptions();
            options.ShowSaveAndNewButtonInToolbar = true;
            options.AutoFitContentArea = false;
            return options;
        }
        protected form = new OthersForm(this.idPrefix);
        constructor() {
            super();

            this.form.ProductCode.changeSelect2(e => {
                let id: number = 0;
                OMS.OthersService.List({ ProductCode: this.form.ProductCode.value.toUpperCase() },
                    response => {
                        if (response.Entities != null && response.Entities.length > 0)
                            id = response.Entities[0].ProductId;
                    }, { async: false });
                if (id == 0) {
                    this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                    return;
                }
                else if (id  != null || id  > 0) {
                    Q.notifyError("Duplicate Material Code " + this.form.ProductCode.value);
                    this.form.ProductCode.value = "";
                    return;

                }
            });
            this.form.ProductTypeId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                this.form.ItemTypeId.value = 106;
                this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                this.form.CategoryId.updateItems();
                q.showAndSetRequiredField(this.form.CategoryId);

            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                q.showAndSetRequiredField(this.form.SubCategoryId);
            });

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            q.showAndDisableField(this.form.CategoryId);
            q.showAndDisableField(this.form.SubCategoryId);
        } 

    }
}